<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: zhiqiang.xia@dsicm.com
 * @Date: 2021-07-07 18:18:46
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2021-07-09 16:57:45
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\views\DoctorSnurses\components\RightContent\index.vue
-->
<template>
    <div class="rightContent">
        <el-tabs v-model="activeName">
            <el-tab-pane label="订单详情" name="first"></el-tab-pane>
        </el-tabs>
        <el-scrollbar style="height: 100%;font-size: 12px">
        <el-form ref="form" size='small' :model="form" label-position='left' label-width="180px">
            <el-form-item label="订单编号：">
                <span>{{ form.orderId }}</span>
            </el-form-item>
            <el-form-item label="订单状态：">
                <span>{{ form.status == 1 ? '待支付' : form.status == 2 ? '已支付' : form.status == 3 ? '已接单' : form.status == 4 ? '已出发' : form.status == 5 ? '已到达' : form.status == 6 ? '已完成（护士）' : form.status == 7 ? '已完成（患者）' : form.status == 8 ? '已取消（患者取消）' : form.status == 9 ? '已取消（护士取消）' : form.status == 10 ? '异常终止' : '' }}</span>
            </el-form-item>
            <el-form-item label="医护上门服务：">
                <span>{{ form.nursingDefinitionName }}</span>
            </el-form-item>
            <el-form-item label="接单医护姓名：">
                <span>{{ form.doctorName }}</span>
            </el-form-item>
            <el-form-item label="接单医护联系方式：">
                <span>{{ form.doctorPhone }}</span>
            </el-form-item>
            <el-form-item label="护士长姓名：">
                <span>{{ form.matronName }}</span>
            </el-form-item>
            <el-form-item label="护士长联系方式：">
                <span>{{ form.matronPhone }}</span>
            </el-form-item>
            <el-form-item label="被服务人姓名：">
                <span>{{ form.patientName }}</span>
            </el-form-item>
            <el-form-item label="被服务人联系方式：">
                <span>{{ form.patientPhone }}</span>
            </el-form-item>
            <el-form-item label="上门服务地址：">
                <span>{{ form.addressDetail }}</span>
            </el-form-item>
            <el-form-item label="下单时间：">
                <span>{{ form.createTime }}</span>
            </el-form-item>
            <el-form-item label="接单时间：">
                <span>{{ form.receiveTime }}</span>
            </el-form-item>
            <el-form-item label="开始时间：">
                <span>{{ form.estimatedStartTime }}</span>
            </el-form-item>
            <el-form-item label="建议服务时长：" style="margin-bottom:100px">
                <span  v-if="form.nursingDefinitionJson">{{ form.nursingDefinitionJson.serviceTime }} {{ form.nursingDefinitionJson.serviceTimeUnit == 1 ? "小时" : '分钟'  }}</span>
            </el-form-item>
        </el-form>
        </el-scrollbar>
    </div>
</template>

<script>
    export default {
        props: {
            rightInfo:Array | Object
        },
        data() {
            return {
                activeName: "first",
                form:{},
            }
        },
        watch: {
            rightInfo(newValue, oldValue) {
                if(newValue){
                    this.form = newValue
                    this.form.nursingDefinitionJson = JSON.parse(newValue.nursingDefinitionJson)
                }
            },
        },
    }
</script>

<style lang="less" scoped>
.rightContent{
    padding: 0px 10px;
    height: calc(100vh - 249px);
    width: 100%;
    overflow: hidden;
    span{
        color: #333;
        font-size: 12px;
    }
}
/deep/.el-scrollbar__wrap{
    overflow-x: hidden;
}
/deep/.el-form-item__label{
    font-size: 12px;
}

</style>